<div class="">
    <div class="sectionlabel">Today's Menu Options</div>

    <div class="twentypxtop"></div>
    <div class="allFAQS" *ngFor="let menuitem of MenuItems; let i=index;">
        <div class="">
            <div class="mealtype" *ngIf="i==0 || menuitem?.mttName != MenuItems[i-1].mttName ">
                <span *ngIf="menuitem.mttName!='Breakfast Entree'">{{menuitem.mttName}}</span>
                <span *ngIf="menuitem.mttName=='Breakfast Entree'">Breakfast Feature of the Day</span>
            </div>
            <div class="tenpxtop"></div>
            <div class="mealname">
                {{menuitem.micName}}
            </div>
            <div class="mealdesc" *ngIf="menuitem.micGuestDescription!=undefined">
                -{{menuitem.micGuestDescription}}
            </div>

        </div>

        <div class="tenpxtop"></div>
    </div>
    <div class="tenpxtop"></div>
    <div class="disclaimer">
        *Items marked with an asterisk may be served raw or undercooked. Consuming raw or undercooked meats, poultry,
        seafood,
        shellfish, or eggs may increase your risk of foodborne illness, especially if you have certain medical
        conditions.
        Please advise your server of any food allergies. Our food may have come in contact or contain peanuts, tree
        nuts, soy,
        milk, eggs, wheat, shellfish, sesame, or fish.
    </div>
    <div class="tenpxtop"></div>
</div>